import React, { ReactElement, useEffect, useRef, useState } from "react"
import Tooltip from "../Tooltip/Tooltip"

type TooltipProps = { dark?: boolean; placement?: "top" | "bottom" | "left" | "right" }

interface Props extends TooltipProps {
  children: string
}

const OverflowText = ({ children, ...props }: Props): ReactElement => {
  const ref = useRef<HTMLDivElement>(null)
  const [isOverflown, setIsOverflown] = useState<boolean>(false)

  useEffect(() => {
    const element = ref.current
    element && setIsOverflown(element.scrollWidth > element.clientWidth)
  }, [children])

  return (
    <Tooltip placement="bottom" content={children} isDisabled={!isOverflown} {...props}>
      <div className="text-sm truncate" ref={ref}>
        {children}
      </div>
    </Tooltip>
  )
}

export default OverflowText
